export default {
  title: '{{company}} a mis à jour votre heure de retrait',
  new_time_label: 'Nouvelle heure',
};
